"use client";

import { useQueryClient } from "@tanstack/react-query";
import { useLayoutEffect } from "react";

import { registerScrollQueryClient } from "@/lib/client/scroll-query-cache-bridge";

/** Registers the app QueryClient for notebook → scroll cache sync. */
export function ScrollQueryCacheBridge() {
  const qc = useQueryClient();

  useLayoutEffect(() => {
    registerScrollQueryClient(qc);
  }, [qc]);

  return null;
}
